/**
 * Summernote 표 병합/분할 플러그인
 * 표 popover에 병합/분할 버튼 추가
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('jquery'));
  } else {
    factory(window.jQuery);
  }
})(function ($) {
  'use strict';

  // 전역 변수: 선택된 셀 정보 저장
  var savedSelectedCells = null;
  
  // 표 병합 함수 - 선택된 셀들을 모두 병합
  function mergeTableCells() {
    var $editor = $('.note-editable:focus');
    if ($editor.length === 0) {
      $editor = $('.note-editable').first();
    }
    
    // 방법 1: 저장된 선택된 셀 정보 사용
    var $selectedCells = null;
    if (savedSelectedCells && savedSelectedCells.length > 0) {
      // DOM 요소 배열을 jQuery 객체 배열로 변환
      $selectedCells = savedSelectedCells.map(function(cell) {
        return $(cell);
      });
    }
    
    // 방법 2: 드래그 선택된 셀들 찾기 (cell-selected 클래스 사용)
    if (!$selectedCells || $selectedCells.length < 2) {
      var $cellsWithClass = $('.note-editable table td.cell-selected, .note-editable table th.cell-selected');
      if ($cellsWithClass.length >= 2) {
        // jQuery 객체를 배열로 변환
        $selectedCells = [];
        $cellsWithClass.each(function() {
          $selectedCells.push($(this));
        });
      }
    }
    
    // 선택된 셀 검증
    if (!$selectedCells || $selectedCells.length < 2) {
      
      // 방법 3: window.getSelection() 사용
      var selection = window.getSelection();
      
      if (!selection || selection.rangeCount === 0) {
        alert('병합할 셀을 선택해주세요.\n\n사용법:\n1. 마우스로 드래그하여 병합할 셀들을 선택\n2. 셀 병합 버튼 클릭');
        return;
      }

      var range = selection.getRangeAt(0);
      
      // 선택된 범위 내의 모든 셀 찾기
      var $startCell = $(range.startContainer).closest('td, th');
      var $endCell = $(range.endContainer).closest('td, th');
      
      if ($startCell.length === 0 || $endCell.length === 0) {
        alert('표 셀을 선택해주세요.');
        return;
      }

      var $table = $startCell.closest('table');
      if ($table.length === 0) {
        return;
      }

      // 선택된 범위의 실제 셀 위치 계산
      var startRow = $startCell.closest('tr').index();
      var endRow = $endCell.closest('tr').index();
      var startCol = $startCell.index();
      var endCol = $endCell.index();
      
      // 행과 열 인덱스를 정렬
      var minRow = Math.min(startRow, endRow);
      var maxRow = Math.max(startRow, endRow);
      var minCol = Math.min(startCol, endCol);
      var maxCol = Math.max(startCol, endCol);
      
      // 선택된 영역의 모든 실제 셀 수집 (병합된 셀 고려)
      $selectedCells = [];
      var processedCells = new Set();
      
      $table.find('tr').each(function(rowIdx) {
        if (rowIdx < minRow || rowIdx > maxRow) return;
        
        var $row = $(this);
        var colIdx = 0;
        
        $row.find('td, th').each(function() {
          var $cell = $(this);
          var cellId = $cell[0];
          
          if (processedCells.has(cellId)) return;
          
          var colspan = parseInt($cell.attr('colspan') || '1');
          var rowspan = parseInt($cell.attr('rowspan') || '1');
          
          // 셀의 실제 범위 계산
          var cellStartCol = colIdx;
          var cellEndCol = colIdx + colspan - 1;
          var cellStartRow = rowIdx;
          var cellEndRow = rowIdx + rowspan - 1;
          
          // 선택된 영역과 겹치는지 확인
          if (cellStartRow <= maxRow && cellEndRow >= minRow &&
              cellStartCol <= maxCol && cellEndCol >= minCol) {
            $selectedCells.push($cell);
            processedCells.add(cellId);
          }
          
          colIdx += colspan;
        });
      });
    }
    
    // $selectedCells가 배열이 아닌 경우 배열로 변환
    if ($selectedCells && !Array.isArray($selectedCells)) {
      var selectedCellsArray = [];
      $selectedCells.each(function() {
        selectedCellsArray.push($(this));
      });
      $selectedCells = selectedCellsArray;
    }
    
    if ($selectedCells.length < 2) {
      alert('병합하려면 최소 2개 이상의 셀을 선택해주세요.');
      return;
    }
    
    // $selectedCells가 jQuery 객체 배열인지 확인하고 첫 번째 셀 찾기
    var $firstCell = $selectedCells.length > 0 ? 
      ($selectedCells[0].jquery ? $selectedCells[0] : $($selectedCells[0])) : 
      null;
    
    if (!$firstCell || $firstCell.length === 0) {
      alert('표 셀을 찾을 수 없습니다.');
      return;
    }
    
    var $table = $firstCell.closest('table');
    if ($table.length === 0) {
      return;
    }

    // 모든 셀의 내용 수집 및 범위 계산
    var allContents = [];
    var actualMinRow = Infinity;
    var actualMaxRow = -Infinity;
    var actualMinCol = Infinity;
    var actualMaxCol = -Infinity;
    
    // 선택된 셀들의 실제 범위를 고려하여 계산
    $selectedCells.forEach(function(cell) {
      var $cell = cell.jquery ? cell : $(cell);
      var content = $cell.html().trim();
      if (content && content !== '&nbsp;') {
        allContents.push(content);
      }
      
      var $row = $cell.closest('tr');
      var rowIdx = $row.index();
      var colIdx = $cell.index();
      var colspan = parseInt($cell.attr('colspan') || '1');
      var rowspan = parseInt($cell.attr('rowspan') || '1');
      
      actualMinRow = Math.min(actualMinRow, rowIdx);
      actualMaxRow = Math.max(actualMaxRow, rowIdx + rowspan - 1);
      actualMinCol = Math.min(actualMinCol, colIdx);
      actualMaxCol = Math.max(actualMaxCol, colIdx + colspan - 1);
    });
    
    var mergedContent = allContents.join(' ') || '&nbsp;';
    var rowSpan = actualMaxRow - actualMinRow + 1;
    var colSpan = actualMaxCol - actualMinCol + 1;
    
    // 첫 번째 셀에 colspan과 rowspan 설정
    $firstCell.attr('colspan', colSpan);
    $firstCell.attr('rowspan', rowSpan);
    $firstCell.html(mergedContent);
    
    // 병합된 셀의 폭 고정 및 워드랩 설정
    var currentWidth = $firstCell.width();
    if (currentWidth > 0) {
      $firstCell.css({
        'width': currentWidth + 'px',
        'min-width': currentWidth + 'px',
        'max-width': currentWidth + 'px',
        'word-wrap': 'break-word',
        'overflow-wrap': 'break-word',
        'white-space': 'normal',
        'height': 'auto'
      });
    }
    
    // 나머지 셀들 제거 (첫 번째 셀 제외)
    for (var i = 0; i < $selectedCells.length; i++) {
      var $cell = $selectedCells[i].jquery ? $selectedCells[i] : $($selectedCells[i]);
      if ($cell[0] !== $firstCell[0]) {
        $cell.remove();
      }
    }
    
    // 표에 table-layout: fixed 강제 적용
    $table.css('table-layout', 'fixed');
    
    // 선택 하이라이트 제거
    $table.find('td.cell-selected, th.cell-selected').removeClass('cell-selected');
    
    // 저장된 선택된 셀 정보 초기화
    savedSelectedCells = null;
    
    // 서머노트에 변경사항 알림
    $editor.trigger('input');
  }

  // Summernote popover를 직접 표시하는 함수
  function showTablePopover($targetCell) {
    var $editable = $targetCell.closest('.note-editable');
    if ($editable.length === 0) {
      return;
    }

    // 셀에 포커스 설정 (Summernote 재초기화 방지를 위해 stopPropagation 사용)
    try {
      var range = document.createRange();
      var sel = window.getSelection();
      range.selectNodeContents($targetCell[0]);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    } catch (err) {
      // 커서 설정 실패 시 무시
    }

    // Summernote context 가져오기 (여러 방법 시도)
    var summernoteInstance = null;
    var context = null;
    
    // 방법 1: data('summernote')로 가져오기
    try {
      summernoteInstance = $editable.data('summernote');
      if (summernoteInstance && summernoteInstance.context) {
        context = summernoteInstance.context;
      }
    } catch (e) {
      // 인스턴스 찾기 실패 시 무시
    }
    
    // 방법 2: jQuery의 summernote 메서드로 가져오기 (재초기화 방지를 위해 'code' 호출 제거)
    // 주의: summernote('code') 호출은 Summernote를 재초기화할 수 있으므로 사용하지 않음
    if (!context && typeof $.fn.summernote !== 'undefined') {
      try {
        // data('summernote')로 직접 접근 (재초기화 방지)
        summernoteInstance = $editable.data('summernote');
        if (summernoteInstance && summernoteInstance.context) {
          context = summernoteInstance.context;
        }
      } catch (e) {
        // 인스턴스 찾기 실패 시 무시
      }
    }
    
    // 방법 3: 직접 DOM에서 찾기
    if (!context) {
      try {
        var editorElement = $editable[0];
        if (editorElement && editorElement.__summernote) {
          summernoteInstance = editorElement.__summernote;
          if (summernoteInstance && summernoteInstance.context) {
            context = summernoteInstance.context;
          }
        }
      } catch (e) {
        // 인스턴스 찾기 실패 시 무시
      }
    }

    // popover 직접 표시 (클릭 이벤트 없이, Summernote 재초기화 방지)
    try {
      // 방법 1: context.invoke로 popover.show 호출 (context가 있는 경우만)
      if (context && context.invoke && typeof context.invoke === 'function') {
        try {
          context.invoke('popover.show', $targetCell);
        } catch (e) {
          // context.invoke 실패 시 무시
        }
      }
      
      // 방법 2: Summernote의 popover UI 직접 찾아서 표시 (가장 확실한 방법)
      setTimeout(function() {
        // 해당 편집 영역에 속한 popover만 찾기 (중복 방지)
        var $editableParent = $editable.closest('.note-editor, .note-frame');
        var $allPopovers = $('.note-popover');
        
        // 다른 편집 영역의 popover는 먼저 숨기기 (중복 방지)
        if ($editableParent.length > 0) {
          $allPopovers.not($editableParent.find('.note-popover')).hide();
          var $popovers = $editableParent.find('.note-popover');
        } else {
          // 편집 영역을 찾지 못한 경우, 현재 셀이 속한 편집 영역의 popover만 찾기
          var $cellEditable = $targetCell.closest('.note-editable');
          var $cellEditor = $cellEditable.closest('.note-editor, .note-frame');
          if ($cellEditor.length > 0) {
            $allPopovers.not($cellEditor.find('.note-popover')).hide();
            var $popovers = $cellEditor.find('.note-popover');
          } else {
            // 모든 popover 숨기고 표 관련 popover만 찾기
            $allPopovers.hide();
            var $popovers = $allPopovers;
          }
        }
        
        if ($popovers.length > 0) {
          // 표 관련 popover만 찾기
          var $tablePopover = null;
          $popovers.each(function() {
            var $popover = $(this);
            // 표 관련 popover인지 확인
            var hasTableBtn = $popover.find('.note-btn[data-event="addRowDown"]').length > 0 ||
                             $popover.find('.note-btn-group.note-add').length > 0 ||
                             $popover.find('.note-icon-row-below').length > 0;
            
            if (hasTableBtn) {
              $tablePopover = $popover;
              return false; // break
            }
          });
          
          if ($tablePopover && $tablePopover.length > 0) {
            
            // 셀 위치 계산 (viewport 기준)
            var cellOffset = $targetCell.offset();
            var cellWidth = $targetCell.width();
            var cellHeight = $targetCell.height();
            var popoverWidth = $tablePopover.outerWidth() || 200;
            var popoverHeight = $tablePopover.outerHeight() || 100;
            
            // 셀 아래쪽 중앙에 배치
            var top = cellOffset.top + cellHeight + 5;
            var left = cellOffset.left + (cellWidth / 2) - (popoverWidth / 2);
            
            // 화면 경계 체크
            var windowWidth = $(window).width();
            var windowHeight = $(window).height();
            var scrollTop = $(window).scrollTop();
            var scrollLeft = $(window).scrollLeft();
            
            // 오른쪽 경계 체크
            if (left + popoverWidth > scrollLeft + windowWidth) {
              left = scrollLeft + windowWidth - popoverWidth - 10;
            }
            // 왼쪽 경계 체크
            if (left < scrollLeft) {
              left = scrollLeft + 10;
            }
            // 아래쪽 경계 체크 (셀 위에 표시)
            if (top + popoverHeight > scrollTop + windowHeight) {
              top = cellOffset.top - popoverHeight - 5;
            }
            // 위쪽 경계 체크
            if (top < scrollTop) {
              top = scrollTop + 10;
            }
            
            // popover 강제 표시
            $tablePopover.css({
              'display': 'block',
              'visibility': 'visible',
              'opacity': '1',
              'position': 'fixed',
              'top': top + 'px',
              'left': left + 'px',
              'z-index': '10000',
              'margin': '0'
            });
            
            // 숨김 클래스 제거
            $tablePopover.removeClass('hide');
            $tablePopover.show();
            
            // popover가 나타난 후 버튼 추가
            setTimeout(function() {
              addButtonsToPopover();
              initTableResize();
              var $table = $targetCell.closest('table');
              if (!$table.data('resize-enabled')) {
                fixTableCellWidths();
              }
            }, 100);
          }
        }
      }, 100);
    } catch (err) {
      // popover 표시 실패 시 무시
      // 에러 발생 시에도 클릭 이벤트를 발생시키지 않음 (에디터 중복 생성 방지)
      // 대신 popover를 직접 찾아서 표시 시도
      setTimeout(function() {
        var $editableParent = $editable.closest('.note-editor, .note-frame');
        var $popovers = $editableParent.length > 0 ? 
          $editableParent.find('.note-popover') : 
          $('.note-popover');
        
        // 다른 편집 영역의 popover는 숨기기
        $('.note-popover').not($popovers).hide();
        
        $popovers.each(function() {
          var $popover = $(this);
          var hasTableBtn = $popover.find('.note-btn-group.note-add').length > 0;
          if (hasTableBtn) {
            var cellOffset = $targetCell.offset();
            $popover.css({
              'display': 'block',
              'visibility': 'visible',
              'opacity': '1',
              'position': 'fixed',
              'top': (cellOffset.top + 30) + 'px',
              'left': (cellOffset.left) + 'px',
              'z-index': '10000'
            }).show();
          }
        });
        
        addButtonsToPopover();
        initTableResize();
        var $table = $targetCell.closest('table');
        if (!$table.data('resize-enabled')) {
          fixTableCellWidths();
        }
      }, 200);
    }
  }

  // 표 분할 함수
  function splitTableCell() {
    var $editor = $('.note-editable:focus');
    if ($editor.length === 0) {
      $editor = $('.note-editable').first();
    }
    
    var selection = window.getSelection();
    
    if (!selection || selection.rangeCount === 0) {
      return;
    }

    var range = selection.getRangeAt(0);
    var $cell = $(range.startContainer).closest('td, th');
    
    if ($cell.length === 0) {
      return;
    }

    var colspan = parseInt($cell.attr('colspan') || '1');
    var rowspan = parseInt($cell.attr('rowspan') || '1');

    if (colspan === 1 && rowspan === 1) {
      return;
    }

    // 셀 내용에서 리사이즈 핸들 관련 텍스트 제거
    var cellContent = $cell.html();
    // 리사이즈 핸들 관련 클래스나 텍스트 제거
    cellContent = cellContent.replace(/table-resize-handle[^>]*>.*?<\/div>/gi, '');
    cellContent = cellContent.replace(/le-resize-handle-right/gi, '');
    
    var halfContent = cellContent.substring(0, Math.floor(cellContent.length / 2));
    var remainingContent = cellContent.substring(Math.floor(cellContent.length / 2));

    var $table = $cell.closest('table');
    var currentCellWidth = $cell.width();

    if (colspan > 1) {
      $cell.attr('colspan', '1');
      $cell.html(halfContent || '&nbsp;');
      
      // 분할된 셀의 폭 고정 및 워드랩 설정
      var splitWidth = currentCellWidth / colspan;
      $cell.css({
        'width': splitWidth + 'px',
        'min-width': splitWidth + 'px',
        'max-width': splitWidth + 'px',
        'word-wrap': 'break-word',
        'overflow-wrap': 'break-word',
        'white-space': 'normal',
        'height': 'auto'
      });
      
      for (var i = 1; i < colspan; i++) {
        var $newCell = $('<td>' + (i === 1 ? remainingContent : '&nbsp;') + '</td>');
        $cell.after($newCell);
        $newCell.css({
          'width': splitWidth + 'px',
          'min-width': splitWidth + 'px',
          'max-width': splitWidth + 'px',
          'word-wrap': 'break-word',
          'overflow-wrap': 'break-word',
          'white-space': 'normal',
          'height': 'auto'
        });
      }
    }

    if (rowspan > 1) {
      $cell.attr('rowspan', '1');
      var $row = $cell.closest('tr');
      var cellIndex = $cell.index();
      
      for (var j = 1; j < rowspan; j++) {
        var $targetRow = $row.nextAll('tr').eq(j - 1);
        if ($targetRow.length > 0) {
          var $cells = $targetRow.find('td, th');
          var $newCell = $('<td>' + (j === 1 ? remainingContent : '&nbsp;') + '</td>');
          
          if (cellIndex === 0) {
            $targetRow.prepend($newCell);
          } else if (cellIndex >= $cells.length) {
            $targetRow.append($newCell);
          } else {
            $cells.eq(cellIndex - 1).after($newCell);
          }
          
          // 분할된 셀의 폭 고정 및 워드랩 설정
          $newCell.css({
            'width': currentCellWidth + 'px',
            'min-width': currentCellWidth + 'px',
            'max-width': currentCellWidth + 'px',
            'word-wrap': 'break-word',
            'overflow-wrap': 'break-word',
            'white-space': 'normal',
            'height': 'auto'
          });
        }
      }
    }
    
    // 표에 table-layout: fixed 강제 적용
    $table.css('table-layout', 'fixed');
    
    // 서머노트에 변경사항 알림
    $editor.trigger('input');
  }

  // 표 popover에 병합/분할 버튼 추가
  function addButtonsToPopover() {
    // 모든 popover 찾기 (visible 여부와 관계없이)
    var $popovers = $('.note-popover');
    
    if ($popovers.length === 0) {
      // body 전체에서 찾기
      $popovers = $('body').find('.note-popover');
    }
    
    if ($popovers.length === 0) {
      return;
    }
    
    $popovers.each(function() {
      var $popover = $(this);
      
      // 표 관련 버튼이 있는지 확인 (표 popover인지 판단)
      // 버튼 그룹으로 확인 (가장 확실한 방법)
      var hasAddGroup = $popover.find('.note-btn-group.note-add').length > 0;
      var hasDeleteGroup = $popover.find('.note-btn-group.note-delete').length > 0;
      var isTablePopover = hasAddGroup && hasDeleteGroup;
      
      // 아이콘 클래스 기반으로도 확인 (버튼 내부의 아이콘)
      if (!isTablePopover) {
        var $tableIcons = $popover.find('.note-icon-row-below, .note-icon-row-above, .note-icon-col-before, .note-icon-col-after, .note-icon-row-remove, .note-icon-col-remove, .note-icon-trash');
        var hasTableIcons = $tableIcons.length > 0;
        isTablePopover = hasTableIcons;
      }
      
      // data-event 속성으로도 찾기 (혹시 모를 경우)
      if (!isTablePopover) {
        var $tableEvents = $popover.find('.note-btn[data-event="addRowDown"], .note-btn[data-event="addRowUp"], .note-btn[data-event="addColLeft"], .note-btn[data-event="addColRight"], .note-btn[data-event="deleteRow"], .note-btn[data-event="deleteCol"], .note-btn[data-event="deleteTable"]');
        var hasTableEvents = $tableEvents.length > 0;
        isTablePopover = hasTableEvents;
      }
      
      var hasTableButtons = isTablePopover;
      
      if (hasTableButtons) {
        // 이미 버튼이 추가되었는지 확인
        if ($popover.find('.note-table-merge-split-buttons').length === 0) {
          // popover의 실제 구조 확인
          // 실제 구조: .note-popover > .popover-content.note-children-container > .note-btn-group
          var $targetContainer = null;
          
          // 1. popover-content 찾기 (실제 구조에 맞춤)
          $targetContainer = $popover.find('.popover-content.note-children-container');
          
          // 2. 없으면 popover-content만 찾기
          if ($targetContainer.length === 0) {
            $targetContainer = $popover.find('.popover-content');
          }
          
          // 3. 없으면 note-children-container 찾기
          if ($targetContainer.length === 0) {
            $targetContainer = $popover.find('.note-children-container');
          }
          
          // 4. 없으면 note-btn-group의 마지막 그룹 뒤에 추가
          if ($targetContainer.length === 0) {
            var $lastBtnGroup = $popover.find('.note-btn-group').last();
            if ($lastBtnGroup.length > 0) {
              $targetContainer = $lastBtnGroup.parent();
            }
          }
          
          // 5. 그래도 없으면 popover 자체에 추가
          if (!$targetContainer || $targetContainer.length === 0) {
            $targetContainer = $popover;
          }
          
          // 병합/분할 버튼 그룹 추가
          var $buttonGroup = $('<div class="note-table-merge-split-buttons" style="padding: 10px; border-top: 1px solid #ddd; margin-top: 8px; text-align: center; clear: both; width: 100%; box-sizing: border-box; background-color: #f8f9fa;">' +
            '<div style="font-size: 11px; color: #666; margin-bottom: 8px; line-height: 1.4;">' +
            '💡 <strong>사용법:</strong> 병합할 셀들을 드래그로 선택 후 버튼 클릭' +
            '</div>' +
            '<button type="button" class="note-btn" data-action="mergeCells" style="margin-right: 8px; padding: 8px 16px; font-size: 13px; font-weight: 500; background-color: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; display: inline-block; min-width: 90px; white-space: nowrap;" title="병합할 셀들을 드래그로 선택한 후 클릭">' +
            '셀 병합' +
            '</button>' +
            '<button type="button" class="note-btn" data-action="splitCell" style="padding: 8px 16px; font-size: 13px; font-weight: 500; background-color: #17a2b8; color: white; border: none; border-radius: 4px; cursor: pointer; display: inline-block; min-width: 90px; white-space: nowrap;" title="병합된 셀을 분할하려면 셀을 클릭한 후 버튼 클릭">' +
            '셀 분할' +
            '</button>' +
            '</div>');
          
          $targetContainer.append($buttonGroup);
          
          // 버튼 클릭 이벤트
                $buttonGroup.find('[data-action="mergeCells"]').on('click', function(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  // 병합 함수 호출 (클래스 제거는 병합 함수 내부에서 처리)
                  mergeTableCells();
                  
                  // 선택된 셀 하이라이트 제거 (병합 후)
                  $('.note-editable table td.cell-selected, .note-editable table th.cell-selected').removeClass('cell-selected');
                  
                  $popover.hide();
                });
          
          $buttonGroup.find('[data-action="splitCell"]').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            splitTableCell();
            $popover.hide();
          });
        }
      }
    });
  }

  // 표 셀 폭 고정 함수 (리사이즈가 활성화되지 않은 표에만 적용)
  function fixTableCellWidths() {
    $('.note-editable table').each(function() {
      var $table = $(this);
      
      // 리사이즈가 활성화된 표는 건너뛰기 (마우스로만 폭 조절)
      if ($table.data('resize-enabled')) {
        return;
      }
      
      // table-layout: fixed 설정
      $table.css('table-layout', 'fixed');
      
      // 각 셀에 폭 고정 및 자동 개행 설정
      $table.find('td, th').each(function() {
        var $cell = $(this);
        if (isFlexLayoutCell($cell)) {
          $cell.css({
            'word-wrap': 'break-word',
            'overflow-wrap': 'break-word',
            'white-space': 'normal'
          });
          return;
        }
        // 현재 폭이 없으면 기본 폭 설정
        if (!$cell.attr('width') && !$cell.css('width')) {
          var colspan = parseInt($cell.attr('colspan') || '1');
          var tableWidth = $table.width();
          var colCount = $table.find('tr').first().find('td, th').length;
          
          // colspan을 고려한 기본 폭 계산
          var baseWidth = (tableWidth / colCount) * colspan;
          $cell.css('width', baseWidth + 'px');
        }
        
        // 자동 개행 및 높이 자동 조절 설정
        $cell.css({
          'word-wrap': 'break-word',
          'overflow-wrap': 'break-word',
          'white-space': 'normal',
          'min-width': '50px',
          'max-width': '100%'
        });
      });
    });
  }

  // 연차/휴가 구분 등 display:flex 셀 여부 (이 셀은 폭/스타일 덮어쓰지 않음)
  function isFlexLayoutCell($cell) {
    return $cell.find('input[name="d1008-type"]').length > 0;
  }

  // 표 리사이즈 기능 초기화
  function initTableResize() {
    $('.note-editable table').each(function() {
      var $table = $(this);
      
      // 이미 리사이즈가 활성화된 표는 건너뛰기
      if ($table.data('resize-initialized')) {
        return;
      }
      
      $table.data('resize-initialized', true);
      
      // table-layout을 auto로 변경하여 리사이즈 가능하게
      $table.css({
        'table-layout': 'auto',
        'position': 'relative',
        'display': 'table'
      });
      $table.data('resize-enabled', true);
      
      // 각 셀에 폭 고정 설정 (타이핑 시 변경되지 않도록)
      $table.find('td, th').each(function() {
        var $cell = $(this);
        if (isFlexLayoutCell($cell)) {
          $cell.css({
            'word-wrap': 'break-word',
            'overflow-wrap': 'break-word',
            'white-space': 'normal'
          });
          return;
        }
        // 현재 폭을 고정 (타이핑 시 변경되지 않도록)
        if (!$cell.css('width') || $cell.css('width') === 'auto') {
          var currentWidth = $cell.width();
          if (currentWidth > 0) {
            $cell.css('width', currentWidth + 'px');
          }
        }
        // 자동 개행 설정
        $cell.css({
          'word-wrap': 'break-word',
          'overflow-wrap': 'break-word',
          'white-space': 'normal',
          'min-width': '50px'
        });
      });
      
      // 표 전체 폭 조절 핸들 추가
      addTableWidthResizeHandle($table);
      
      // 각 셀에 높이 조절 핸들 추가 (폭 조절은 개별적으로, 연차/휴가 구분 셀 제외)
      $table.find('td, th').each(function() {
        addCellResizeHandle($(this), $table);
      });
      
      // 새로 추가되는 셀에도 리사이즈 핸들 추가
      var resizeObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              var $node = $(node);
              if ($node.is('td, th') || $node.find('td, th').length > 0) {
                $table.find('td, th').each(function() {
                  var $cell = $(this);
                  if (!$cell.data('resize-handle-added')) {
                    addCellResizeHandle($cell, $table);
                  }
                });
              }
            }
          });
        });
      });
      
      resizeObserver.observe($table[0], {
        childList: true,
        subtree: true
      });
    });
  }

  // 표 전체 폭 조절 핸들 추가
  function addTableWidthResizeHandle($table) {
    if ($table.data('table-width-resize-added')) {
      return;
    }
    
    $table.data('table-width-resize-added', true);
    $table.css('position', 'relative');
    
    // 오른쪽 테두리 리사이즈 핸들 (표 전체 폭 조절)
    var $tableResizeHandle = $('<div class="table-width-resize-handle"></div>');
    $table.append($tableResizeHandle);
    
    $tableResizeHandle.on('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var startX = e.pageX;
      var startWidth = $table.width();
      var $editable = $table.closest('.note-editable');
      var editableWidth = $editable.width();
      
      $('body').addClass('table-resizing');
      
      $(document).on('mousemove.tableWidthResize', function(e) {
        var diffX = e.pageX - startX;
        var newWidth = Math.max(100, Math.min(editableWidth, startWidth + diffX));
        // 표 전체 폭 조절
        $table.css('width', newWidth + 'px');
        
        // 모든 셀에 워드랩 설정
        $table.find('td, th').css({
          'word-wrap': 'break-word',
          'overflow-wrap': 'break-word',
          'white-space': 'normal',
          'height': 'auto'
        });
      });
      
      $(document).on('mouseup.tableWidthResize', function() {
        $(document).off('mousemove.tableWidthResize mouseup.tableWidthResize');
        $('body').removeClass('table-resizing');
        
        // 리사이즈 완료 후 표 폭 고정
        var finalWidth = $table.width();
        $table.css('width', finalWidth + 'px');
        
        // 표에 table-layout: fixed 강제 적용
        $table.css('table-layout', 'fixed');
        
        $('.note-editable').trigger('input');
      });
    });
  }

  // 셀에 높이 조절 핸들 추가 (폭은 개별 셀별로 조절)
  function addCellResizeHandle($cell, $table) {
    if ($cell.data('resize-handle-added')) {
      return;
    }
    if ($cell.find('.table-resize-handle').length > 0) {
      $cell.data('resize-handle-added', true);
      return;
    }
    if (isFlexLayoutCell($cell)) {
      return;
    }
    
    $cell.data('resize-handle-added', true);
    $cell.css('position', 'relative');
    
    // 오른쪽 테두리 리사이즈 핸들 (개별 셀 폭 조절)
    var $resizeHandleRight = $('<div class="table-resize-handle table-resize-handle-right"></div>');
    $cell.append($resizeHandleRight);
    
    // 아래쪽 테두리 리사이즈 핸들 (행 높이 조절)
    var $resizeHandleBottom = $('<div class="table-resize-handle table-resize-handle-bottom"></div>');
    $cell.append($resizeHandleBottom);
    
    // 오른쪽 리사이즈 이벤트 (개별 셀 폭만 조절)
    $resizeHandleRight.on('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var startX = e.pageX;
      var startWidth = $cell.width();
      var cellIndex = $cell.index();
      var $row = $cell.closest('tr');
      
      $('body').addClass('table-resizing');
      
      $(document).on('mousemove.tableCellResize', function(e) {
        if (isFlexLayoutCell($cell)) return;
        var diffX = e.pageX - startX;
        var newWidth = Math.max(50, startWidth + diffX);
        
        // 현재 셀만 폭 조절 (다른 셀은 영향 없음)
        // width 속성을 명시적으로 설정하여 타이핑 시 변경되지 않도록 함
        $cell.css({
          'width': newWidth + 'px',
          'min-width': newWidth + 'px',
          'max-width': newWidth + 'px',
          'word-wrap': 'break-word',
          'overflow-wrap': 'break-word',
          'white-space': 'normal',
          'height': 'auto'
        });
      });
      
      $(document).on('mouseup.tableCellResize', function() {
        $(document).off('mousemove.tableCellResize mouseup.tableCellResize');
        $('body').removeClass('table-resizing');
        if (isFlexLayoutCell($cell)) return;
        
        // 리사이즈 완료 후 폭 고정 (타이핑 시 변경되지 않도록)
        var finalWidth = $cell.width();
        $cell.css({
          'width': finalWidth + 'px',
          'min-width': finalWidth + 'px',
          'max-width': finalWidth + 'px',
          'word-wrap': 'break-word',
          'overflow-wrap': 'break-word',
          'white-space': 'normal',
          'height': 'auto'
        });
        
        // 표에 table-layout: fixed 강제 적용
        $table.css('table-layout', 'fixed');
        
        $('.note-editable').trigger('input');
      });
    });
    
    // 아래쪽 리사이즈 이벤트 (행 높이 조절)
    $resizeHandleBottom.on('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var startY = e.pageY;
      var startHeight = $cell.height();
      var $row = $cell.closest('tr');
      
      $('body').addClass('table-resizing-row');
      
      $(document).on('mousemove.tableRowResize', function(e) {
        var diffY = e.pageY - startY;
        var newHeight = Math.max(30, startHeight + diffY);
        
        // 같은 행의 다른 셀들도 높이 조절
        $row.find('td, th').each(function() {
          var $rowCell = $(this);
          $rowCell.css({
            'height': newHeight + 'px',
            'word-wrap': 'break-word',
            'overflow-wrap': 'break-word',
            'white-space': 'normal'
          });
        });
      });
      
      $(document).on('mouseup.tableRowResize', function() {
        $(document).off('mousemove.tableRowResize mouseup.tableRowResize');
        $('body').removeClass('table-resizing-row');
        
        // 표에 table-layout: fixed 강제 적용
        $table.css('table-layout', 'fixed');
        
        $('.note-editable').trigger('input');
      });
    });
  }

  // 표 삽입 시 커서 위치에 삽입하도록 수정
  function fixTableInsertion() {
    // 표 삽입 전 커서 위치 저장 (전역 변수로 변경)
    window.savedTableInsertionCursor = null;
    
    // 표 삽입 버튼 클릭 시 커서 위치 저장
    $(document).on('mousedown', '.note-btn[data-event="showTableDialog"], .note-btn-group[data-name="table"] .note-btn', function() {
      var $editable = $('.note-editable:focus');
      if ($editable.length === 0) {
        $editable = $('.note-editable').first();
      }
      
      var selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        var range = selection.getRangeAt(0);
        var container = range.startContainer;
        var offset = range.startOffset;
        
        // 텍스트 노드인 경우 부모 요소 찾기
        if (container.nodeType === 3) {
          container = container.parentNode;
        }
        
        window.savedTableInsertionCursor = {
          container: container,
          offset: offset,
          $editable: $editable,
          range: range.cloneRange()
        };
      }
    });
    
    // 표 삽입 다이얼로그에서 표 크기 선택 시 커서 위치 재저장
    $(document).on('mousedown', '.note-table-dimension-picker-marker', function() {
      var $editable = $('.note-editable:focus');
      if ($editable.length === 0) {
        $editable = $('.note-editable').first();
      }
      
      var selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        var range = selection.getRangeAt(0);
        var container = range.startContainer;
        var offset = range.startOffset;
        
        if (container.nodeType === 3) {
          container = container.parentNode;
        }
        
        window.savedTableInsertionCursor = {
          container: container,
          offset: offset,
          $editable: $editable,
          range: range.cloneRange()
        };
      }
    });
    
    // MutationObserver로 표 삽입 감지
    var tableInsertObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.tagName === 'TABLE') {
            var $table = $(node);
            setTimeout(function() {
              moveTableToCursorPosition($table);
            }, 100);
          }
        });
      });
    });
    
    // 모든 편집 영역 관찰
    $('.note-editable').each(function() {
      tableInsertObserver.observe(this, {
        childList: true,
        subtree: false
      });
    });
    
    // 표가 삽입된 후 위치를 조정
    $(document).on('summernote.table.create', function(we, $table) {
      setTimeout(function() {
        moveTableToCursorPosition($table);
      }, 100);
    });
    
    // 표 위치 이동 함수
    function moveTableToCursorPosition($table) {
      if (!$table || $table.length === 0) {
        return;
      }
      
      var $editable = window.savedTableInsertionCursor ? 
        window.savedTableInsertionCursor.$editable : 
        $('.note-editable:focus');
      
      if ($editable.length === 0) {
        $editable = $('.note-editable').first();
      }
      
      // 표가 편집 영역의 맨 위에 있는지 확인
      var $firstChild = $editable.children().first();
      var isAtTop = $firstChild.length > 0 && $firstChild[0] === $table[0];
      
      if (isAtTop && window.savedTableInsertionCursor) {
        var cursorInfo = window.savedTableInsertionCursor;
        var targetElement = cursorInfo.container;
        
        if (targetElement) {
          var $targetElement = $(targetElement);
          
          // 커서가 있는 블록 요소 찾기
          var $blockElement = $targetElement.closest('p, div, h1, h2, h3, h4, h5, h6, li, blockquote, pre, br');
          
          if ($blockElement.length > 0 && $blockElement.closest('.note-editable').length > 0) {
            // 블록 요소 다음에 표 삽입
            $table.detach();
            $blockElement.after($table);
            
            // 표 다음에 빈 줄 추가
            if ($table.next().length === 0 || !$table.next().is('p, br')) {
              $table.after('<p><br></p>');
            }
          } else {
            // 블록 요소가 없으면 커서 위치의 부모 요소 다음에 삽입
            var $parent = $targetElement.parent();
            
            if ($parent.length > 0 && $parent.closest('.note-editable').length > 0) {
              $table.detach();
              $parent.after($table);
            } else {
              // 편집 영역에 직접 삽입
              var selection = window.getSelection();
              if (selection && selection.rangeCount > 0) {
                try {
                  var range = selection.getRangeAt(0);
                  var container = range.startContainer;
                  if (container.nodeType === 3) {
                    container = container.parentNode;
                  }
                  var $insertPoint = $(container).closest('p, div, h1, h2, h3, h4, h5, h6, li, blockquote, pre');
                  if ($insertPoint.length > 0) {
                    $table.detach();
                    $insertPoint.after($table);
                  }
                } catch (e) {
                  // 삽입 실패 시 무시
                }
              }
            }
          }
          
          // 커서를 표 첫 번째 셀로 이동
          setTimeout(function() {
            var $firstCell = $table.find('td, th').first();
            if ($firstCell.length > 0) {
              try {
                var newRange = document.createRange();
                var sel = window.getSelection();
                newRange.selectNodeContents($firstCell[0]);
                newRange.collapse(true);
                sel.removeAllRanges();
                sel.addRange(newRange);
              } catch (e) {
                // 커서 이동 실패 시 무시
              }
            }
          }, 50);
          
          // 서머노트에 변경사항 알림
          $editable.trigger('input');
        }
        
        // 저장된 커서 위치 초기화
        window.savedTableInsertionCursor = null;
      }
    }
  }

  // 서머노트 초기화 후 처리
  function initAfterSummernote() {
    // 서머노트가 로드되었는지 확인
    if (typeof $.fn.summernote === 'undefined') {
      setTimeout(initAfterSummernote, 100);
      return;
    }
    
    // 표 삽입 기능 수정
    fixTableInsertion();

    // 서머노트 popover.show 이벤트 후킹
    var originalPopoverShow = null;
    
    // 서머노트의 PopoverUI 찾기
    if ($.summernote && $.summernote.ui && $.summernote.ui.PopoverUI) {
      var PopoverUI = $.summernote.ui.PopoverUI;
      if (PopoverUI.prototype && PopoverUI.prototype.show) {
        originalPopoverShow = PopoverUI.prototype.show;
        PopoverUI.prototype.show = function() {
          var result = originalPopoverShow.apply(this, arguments);
          setTimeout(function() {
            addButtonsToPopover();
          }, 50);
          return result;
        };
      }
    }

    // MutationObserver로 popover가 나타날 때 감지
    var popoverObserver = new MutationObserver(function(mutations) {
      var shouldCheck = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.nodeType === 1) {
              var $node = $(node);
              if ($node.hasClass('note-popover') || $node.find('.note-popover').length > 0) {
                shouldCheck = true;
                break;
              }
            }
          }
        }
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
          var $target = $(mutation.target);
          if ($target.hasClass('note-popover') && $target.is(':visible')) {
            shouldCheck = true;
          }
        }
      });
      
      if (shouldCheck) {
        setTimeout(function() {
          addButtonsToPopover();
        }, 50);
      }
    });

    // body 전체를 관찰하여 popover 추가 감지
    popoverObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    // 표 생성/변경 감지 (MutationObserver 사용)
    var tableObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var $node = $(node);
            if ($node.is('table') || $node.find('table').length > 0) {
              setTimeout(function() {
                initTableResize();
                fixTableCellWidths();
              }, 100);
            }
          }
        });
      });
    });
    
    // 모든 .note-editable 영역 관찰
    $('.note-editable').each(function() {
      tableObserver.observe(this, {
        childList: true,
        subtree: true
      });
    });

    // 표 셀 드래그 선택 기능
    var dragState = {
      isDragging: false,
      startCell: null,
      startRow: null,
      startCol: null,
      $currentPopover: null,
      mouseDownTime: null,
      hasMoved: false,
      isSimulatingEvents: false // 이벤트 시뮬레이션 중 플래그
    };
    
    // 드래그 시작
    $(document).on('mousedown', '.note-editable table td, .note-editable table th', function(e) {
      var $cell = $(this);
      var $table = $cell.closest('table');
      
      // 드래그 시작 시 popover 숨기기
      dragState.$currentPopover = $('.note-popover:visible');
      if (dragState.$currentPopover.length > 0) {
        dragState.$currentPopover.hide();
      }
      
      // 기존 선택 하이라이트 제거
      $table.find('td.cell-selected, th.cell-selected').removeClass('cell-selected');
      
      dragState.startCell = $cell[0];
      dragState.startRow = $cell.closest('tr').index();
      dragState.startCol = $cell.index();
      dragState.isDragging = false;
      dragState.mouseDownTime = Date.now();
      dragState.hasMoved = false;
      
      // 첫 번째 셀 하이라이트
      $cell.addClass('cell-selected');
    });
    
    // 드래그 중
    $(document).on('mousemove', function(e) {
      // 이벤트 시뮬레이션 중이면 무시
      if (dragState.isSimulatingEvents) {
        return;
      }
      
      if (!dragState.startCell) return;
      
      var $startCell = $(dragState.startCell);
      var $table = $startCell.closest('table');
      
      // 마우스 이동 감지
      if (!dragState.hasMoved) {
        var timeDiff = Date.now() - dragState.mouseDownTime;
        if (timeDiff > 50) { // 50ms 이상 지나면 드래그로 간주
          dragState.hasMoved = true;
        }
      }
      
      // 마우스가 셀 위에 있는지 확인
      var $target = $(e.target);
      var $endCell = $target.closest('td, th');
      
      if ($endCell.length > 0 && $endCell.closest('table')[0] === $table[0]) {
        dragState.isDragging = true;
        
        // 기존 선택 하이라이트 제거
        $table.find('td.cell-selected, th.cell-selected').removeClass('cell-selected');
        
        // 선택 범위 계산
        var endRow = $endCell.closest('tr').index();
        var endCol = $endCell.index();
        
        var minRow = Math.min(dragState.startRow, endRow);
        var maxRow = Math.max(dragState.startRow, endRow);
        var minCol = Math.min(dragState.startCol, endCol);
        var maxCol = Math.max(dragState.startCol, endCol);
        
        // 선택된 셀들에 하이라이트 추가
        $table.find('tr').slice(minRow, maxRow + 1).each(function() {
          $(this).find('td, th').slice(minCol, maxCol + 1).each(function() {
            $(this).addClass('cell-selected');
          });
        });
      }
    });
    
    // 드래그 종료
    $(document).on('mouseup', function(e) {
      // 이벤트 시뮬레이션 중이면 무시 (무한 루프 방지)
      if (dragState.isSimulatingEvents) {
        return;
      }
      
      if (dragState.startCell) {
        var $startCell = $(dragState.startCell);
        var $table = $startCell.closest('table');
        var $targetCell = $(e.target).closest('td, th');
        
        // 드래그 상태 저장 (초기화 전에)
        var wasDragging = dragState.isDragging && dragState.hasMoved;
        var $selectedCells = $table.find('td.cell-selected, th.cell-selected');
        
        // 상태를 먼저 초기화하여 중복 처리 방지
        var savedStartCell = dragState.startCell;
        var savedStartRow = dragState.startRow;
        var savedStartCol = dragState.startCol;
        
        dragState.startCell = null;
        dragState.isDragging = false;
        dragState.hasMoved = false;
        dragState.$currentPopover = null;
        
        // 마우스가 셀 위에서 떼어진 경우에만 처리
        if ($targetCell.length === 0 || $targetCell.closest('table')[0] !== $table[0]) {
          // 선택 하이라이트 제거
          $table.find('td.cell-selected, th.cell-selected').removeClass('cell-selected');
          return;
        }
        
        // 마지막으로 클릭한 셀에 커서 설정 (popover 표시를 위해 필요)
        try {
          var range = document.createRange();
          var sel = window.getSelection();
          range.selectNodeContents($targetCell[0]);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        } catch (err) {
          // 커서 설정 실패 시 무시
        }
        
        // 드래그든 클릭이든 상관없이 popover 표시
        setTimeout(function() {
          // 선택된 셀 정보 저장 (병합 버튼 클릭 시 사용)
          if (wasDragging && $selectedCells.length > 0) {
            // 선택된 셀들의 DOM 요소를 배열로 저장
            savedSelectedCells = $selectedCells.toArray();
          } else {
            // 클릭만 한 경우 선택 하이라이트 제거
            $table.find('td.cell-selected, th.cell-selected').removeClass('cell-selected');
            savedSelectedCells = null;
          }
          
          // popover 표시
          showTablePopover($targetCell);
        }, 100);
      }
    });
    
    // 표 클릭 이벤트 감지 제거 (mouseup에서 이미 처리하므로 중복 방지)
    // 주의: click 이벤트는 Summernote의 기본 동작과 충돌하여 에디터 중복 생성 가능

    // 서머노트 이벤트 직접 후킹
    $(document).on('summernote.init', function() {
      setTimeout(function() {
        fixTableInsertion(); // 표 삽입 기능 수정
        addButtonsToPopover();
        initTableResize();
        fixTableCellWidths();
      }, 300);
    });

    // 서머노트 입력 이벤트 감지 (표 내부 타이핑 시 셀 폭 고정)
    $(document).on('input', '.note-editable table td, .note-editable table th', function() {
      var $cell = $(this);
      var $table = $cell.closest('table');
      
      // 현재 셀의 폭을 고정 (입력해도 폭이 변경되지 않도록)
      var currentWidth = $cell.width();
      if (currentWidth > 0) {
        $cell.css({
          'width': currentWidth + 'px',
          'min-width': currentWidth + 'px',
          'max-width': currentWidth + 'px',
          'word-wrap': 'break-word',
          'overflow-wrap': 'break-word',
          'white-space': 'normal',
          'height': 'auto'
        });
      }
      
      // 표에 table-layout: fixed 강제 적용
      $table.css('table-layout', 'fixed');
    });
  }

  // 전역 노출: 툴바 등에서 onclick="window.mergeCells()", "window.splitCell()" 호출 시 사용
  // (가로+세로 2D 병합 지원, 결재 등에서 덮어쓰지 않으면 이 구현이 사용됨)
  window.mergeCells = mergeTableCells;
  window.splitCell = splitTableCell;

  // 문서 로드 시 초기화
  $(document).ready(function() {
    // 서머노트 로드 대기
    initAfterSummernote();
    
    // 주기적으로 popover 확인 및 표 셀 폭 고정
    var checkInterval = setInterval(function() {
      var $popovers = $('.note-popover');
      if ($popovers.length > 0) {
        var $tablePopover = $popovers.filter(function() {
          var hasTableBtn = $(this).find('.note-btn[data-event="addRowDown"]').length > 0 ||
                           $(this).find('.note-btn[data-event="addRowUp"]').length > 0 ||
                           $(this).find('.note-btn[data-event="addColLeft"]').length > 0;
          return hasTableBtn;
        });
        if ($tablePopover.length > 0 && $tablePopover.find('.note-table-merge-split-buttons').length === 0) {
          addButtonsToPopover();
        }
      }
      
      // 표 셀 폭 고정 및 리사이즈 기능 확인
      initTableResize();
      fixTableCellWidths();
    }, 500);
    
    // 초기 로드 시에도 리사이즈 기능 활성화
    setTimeout(function() {
      initTableResize();
    }, 1000);
  });
});
